import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class ExportAllModel extends BaseModel {
  static urlPath = "export-all";
  @attr("json") response;
}
